import * as React from "react";
import { useVersionPolling } from "@/hooks/use-version-polling";
import { VersionUpdateModal } from "@/components/modals/version-update-modal";

interface Props {
  children: React.ReactNode;
}

export const VersionPollingWrapper = ({ children }: Props) => {
  const { isNewVersionAvailable, dismiss } = useVersionPolling();

  return (
    <>
      {children}
      {isNewVersionAvailable && <VersionUpdateModal onDismiss={dismiss} />}
    </>
  );
};
